import { useSelector } from "react-redux";
import { makeProfile } from "@client.pages/Login/reducer";
import { useCallback } from "react";
import { AllRolesExceptViewer } from "@client.enums/userRoles";

const usePermission = () => {
  const profile = useSelector(makeProfile);

  const isAllowed = useCallback(
    (roles = AllRolesExceptViewer) => {
      return roles.indexOf(profile.role) > -1;
    },
    [profile]
  );
  return { isAllowed };
};

export default usePermission;
